module.exports = __webpack_public_path__ + "static/media/openlite-js.2bfce6e9.svg";